// One candidate set for the website and React (web/iOS/Android).
// Keep every page; a partial directory must never look like an empty result.
export async function fetchCompanyDirectory(client, { signal } = {}) {
  const rows = new Map()
  let afterId = null
  const pageSize = 500
  for (;;) {
    if (signal?.aborted) throw Object.assign(new Error('Request aborted'), { name: 'AbortError' })
    let query = client.from('companies').select('*')
      .or('is_suspended.eq.false,is_suspended.is.null')
      .order('id', { ascending: true }).limit(pageSize)
    if (afterId !== null) query = query.gt('id', afterId)
    if (signal) query = query.abortSignal(signal)
    const { data, error } = await query
    if (error) throw error
    const page = Array.isArray(data) ? data : []
    for (const row of page) if (row?.id) rows.set(row.id, row)
    if (page.length < pageSize) break
    const nextId = page[page.length - 1]?.id
    if (!nextId || nextId === afterId) throw new Error('Company directory pagination stalled')
    afterId = nextId
  }
  return [...rows.values()]
}

